module.exports = __webpack_public_path__ + "static/usda-organic-logo.19d9fdbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/hero/usda-organic-logo.png
// module id = 1047
// module chunks = 213534597649335